import { O2OCommonContainer } from '../../../common/container/O2OContainer';
import { IState } from '../../../redux/reducer';
import ConsoleUsersActivityComponentV2 from './ConsoleUsersActivityComponentV2';

function mapStateToProps(rootState: IState) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export const ConsoleUsersActivityContainer = O2OCommonContainer(
  ConsoleUsersActivityComponentV2,
  mapStateToProps,
  mapDispatchToProps
);
